export default __webpack_public_path__ + "static/media/gymshim-full-logo.e53fddae.png";